import React, {FC, useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import styles from './RunCashierBalanceReportStep.module.scss';
import {Button, Flex, Link, Text} from '@priority-software/priority-style-react';
import {Loader, ShowMoreText} from '../../../Components';
import texts from '../../../texts';
import {NextState} from '../../../types';
import {useFooterContext} from '../../../hooks';
import ReportImage from '../../../../../images/EOY-Report-2-image.svg';
import {isRTL} from '../../../../../Localization';
import classNames from 'classnames';
import {runCashierBalanceReport} from '../../../actions/runCashierBalanceReportStep';
import {reportIdByReportName} from '../../../constants';
import {apploadAttachmentsToLog} from '../../../actions/wizardLog';
import {useFiscalYear} from '../../../hooks/useFiscalYear';
import {startEntity} from '../../../../../_shared/GWTBridge/invoke/genPage';

export const RunCashierBalanceReportStep: FC = observer(() => {
    const [reportLoading, setReportLoading] = useState(false);
    const [url, setUrl] = useState<string>();
    const [fiscalYearStateLoaded, fiscalYearState] = useFiscalYear();
    const isRtl = isRTL();
    const footerState = useFooterContext();

    useEffect(() => {
        if (footerState.onNextState === NextState.Processing) {
            footerState.setOnNextState(NextState.Done);
        }
    }, [footerState.onNextState]);

    useEffect(() => {
        footerState.setIsValid(!!url);
    }, [url]);

    const onRunReportClick = () => {
        setReportLoading(true);
        runCashierBalanceReport()
            .then(url => {
                apploadAttachmentsToLog(
                    url,
                    fiscalYearState.exttype,
                    fiscalYearState.nscust,
                    reportIdByReportName['CASHBAL']
                );
                setReportLoading(false);
                setUrl(url);
                footerState.setIsValid(true);
            })
            .catch(() => {
                setReportLoading(false);
                footerState.setIsValid(true);
            });
    };

    return (
        <Flex
            componentClasses={classNames(styles.wrapper, {
                [styles.wrapperRtl]: isRtl
            })}
            justifyContent={'flex-start'}
            direction={'column'}
        >
            <ShowMoreText
                text={texts['stage1_step2_explanation']}
                extendedText={texts['stage1_step2_more_text']}
            />
            <Flex componentClasses={styles.buttonWrapper}>
                <Button
                    componentClasses={styles.button}
                    size={'medium'}
                    width={'fullWidth'}
                    onClick={() => onRunReportClick()}
                    disabled={reportLoading || !fiscalYearStateLoaded}
                >
                    {texts['run_report']}
                </Button>
            </Flex>
            <Loader
                isVisible={reportLoading}
                componentClassname={styles.loader}
                workingLabel={texts['working_on_it']}
            />
            {url !== undefined && (
                <Flex direction={'column'} justifyContent={'center'} componentClasses={styles.info}>
                    <div className={styles.image}>
                        <img src={ReportImage} alt={''} />
                    </div>
                    <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-700'}>
                        {texts['stage_1_step2_links']}
                        <Link target={'_blank'} href={url} componentClasses={styles.link}>
                            <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-500'}>
                                {texts['stage_1_step2_link_name']}
                            </Text>
                        </Link>
                        {texts['stage0_step2_branches_notice_ending']}
                    </Text>
                    <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-700'}>
                        {texts['stage_1_step2_links2']}
                        <Link
                            componentClasses={styles.link}
                            onClick={() => {
                                startEntity(
                                    'EOYLOG',
                                    'GLNAME',
                                    fiscalYearState.year.toString(),
                                    'EXTFILES'
                                );
                            }}
                        >
                            <Text tag={'span'} skin={'paragraph-1'} textColor={'primary-500'}>
                                {texts['stage_1_step2_link2_name']}
                            </Text>
                        </Link>
                        {texts['stage0_step2_branches_notice_ending']}
                    </Text>
                </Flex>
            )}
        </Flex>
    );
});
